<template>
    <div class="card">
        <div class="card-header">
            <slot name="title"></slot>
        </div>
        <div class="card-body">
            <!-- button -->
            <div class="row">
                <div class="col-md-6 mb-1">
                    <slot name="button"></slot>
                </div>

                <div class="col-md-6 mb-1">
                    <slot name="search"></slot>
                </div>
            </div>
            <!-- button -->

            <!-- table -->
            <div class="table-responsive">
                <table class="table mb-0">
                    <slot name="columnHeader"></slot>
                    <tbody>
                        <tr v-for="(data, key, i) in dataTable.lists.data" :key="key">
                            <td>{{ ((dataTable.lists.current_page - 1) * dataTable.lists.per_page + (key > 9 ? i : key) + 1)
                                ||
                                key + 1 }}</td>
                            <td v-for="(column, kcolumn) in dataTable.columns" :key="kcolumn">
                                <span v-if="column == 'no_kontrak'">
                                    <router-link :to="'kontrak/' + data.id" v-html="data[column]"></router-link>
                                </span>
                                <span v-else-if="column == 'no_kontrak_lap'">
                                    <router-link :to="'kontrak/' + data.id_kontrak" v-html="data[column]"></router-link>
                                </span>
                                <span v-else-if="column == 'judul_kontrak'">
                                    <strong>
                                        <slot name="cell(judul_kontrak)" v-bind="data">
                                            <router-link style="font-size: 15px" :to="'kontrak-mtu/detail/' + data.id"
                                                v-html="data[column]"></router-link>
                                        </slot>
                                    </strong>
                                </span>
                                <span class="text-right" v-else-if="column == 'nilai_kontrak'">
                                    <p class="text-right">{{ data[column] | currency }}</p>
                                </span>
                                <span v-else-if="column == 'idr'">
                                    {{ data[column] | currency }}
                                </span>
                                <span v-else-if="column == 'nilai'">
                                    {{ data[column] | currency }}
                                </span>
                                <span v-else-if="column == 'attachments'">
                                    <a v-if="data[column][0]" :href="data[column][0]" target="_blank" class="text-blue">Link
                                        Bukti</a>
                                    <span v-else>-</span>
                                </span>
                                <span v-else v-html="data[column]"></span>
                            </td>
                            <td v-if="noAction !== true">
                                <slot name="action" v-bind:data="data"></slot>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PaginateList :data="dataTable.lists" v-if="dataTable.lists.total != 0 && showPagination" />
        </div>
    </div>
</template>

<script>
import PaginateList from '@/components/PaginateList'

export default {
    name: 'List',
    props: {
        showPagination: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: '',
        },
        noAction: {
            type: Boolean,
            default: false,
        },
        breadcumb: {
            type: String,
            default: '',
        },
        dataTable: {
            type: Object,
            default() {
                return {}
            }
        },
        isBreadcrumb: {
            type: [Boolean, String, Number],
            default: false,
        },
        maxHeight: {
            type: [Number, String],
            default: '500px'
        }
    },
    components: {
        PaginateList
    },
    data() {
        return {
            role_id: localStorage.getItem('role_id')
        }
    }
}
</script>